import { Outlet } from "react-router-dom";

export default function CustomersPage() {
  return (<div> 
      <Outlet/>
  </div>);
}